import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconTextAlignmentLeft';
/** Renders an SVG icon. */
const SvgTextAlignmentLeft = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M28 5a1 1 0 0 0-1-1H5a1 1 0 0 0 0 2h22a1 1 0 0 0 1-1m-10 5a1 1 0 0 0-1-1H5a1 1 0 0 0 0 2h12a1 1 0 0 0 1-1m8 6a1 1 0 0 0-1-1H5a1 1 0 1 0 0 2h20a1 1 0 0 0 1-1m-10 6a1 1 0 0 0-1-1H5a1 1 0 1 0 0 2h10a1 1 0 0 0 1-1m12 5a1 1 0 0 0-1-1H5a1 1 0 1 0 0 2h22a1 1 0 0 0 1-1"
      />
    </svg>
  );
};
SvgTextAlignmentLeft.displayName = displayName;
export default SvgTextAlignmentLeft;
